// @flow

import * as React from 'react'
import { connect, type Connector } from 'react-redux'
import { Button } from 'semantic-ui-react'

import FileDownloaderButton from '../systemwide/file-downloader-button'
import { addErrorNotification } from '../store/notification-manager'
import { openUpdateStatusSidebar, openSystemSidebar } from '../store/app'
import { onModifyRecord, deleteDoctorRequest } from '../store/manage-panel'
import { isAdmin, isEditor } from '../store/authentication'
import type { ReduxState, Dispatch } from '../store'

type OwnProps = {||}

type MappedProps = {|
  currentCampaign: string,
  sortKey: string,
  sortDir: string,
  filter: string,
  totRecords: number,
  selectedRecords: Array<Object>,
  isAdmin: boolean,
  isEditor: boolean,
|}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps): MappedProps => {
  return {
    currentCampaign: state.allowedCampaigns.currentCampaign,
    sortKey: state.panel.grid.sortKey,
    sortDir: state.panel.grid.sortDir,
    filter: state.panel.grid.filterTerms,
    totRecords: state.panel.grid.totRecords,
    selectedRecords: state.panel.grid.selectedRecords,
    isAdmin: isAdmin(state),
    isEditor: isEditor(state),
  }
}

type Props = { dispatch: Dispatch } & OwnProps & MappedProps

class PanelToolbar extends React.Component<Props> {
  static defaultProps = {}

  onOpenSystemSidebar = () => {
    this.props.dispatch(openSystemSidebar())
  }

  onOpenUpdateStatusSidebar = () => {
    this.props.dispatch(openUpdateStatusSidebar())
  }

  onModifyRecord = () => {
    this.props.dispatch(onModifyRecord(this.props.selectedRecords[0]))
  }

  onDeleteDoctor = () => {
    this.props.dispatch(deleteDoctorRequest(this.props.selectedRecords[0]))
  }

  onDownloadError = () => {
    this.props.dispatch(addErrorNotification('Errore di download'))
  }

  render() {
    return (
      <div style={{ float: 'left' }}>
        {(this.props.isAdmin || this.props.isEditor) && (
          <Button
            style={{ minWidth: '20ex', marginRight: '2ex' }}
            icon="upload"
            content="Carica lista"
            labelPosition="left"
            size="small"
            color="green"
            onClick={this.onOpenSystemSidebar}
          />
        )}
        {(this.props.isAdmin || this.props.isEditor) && (
          <Button
            style={{ minWidth: '20ex' }}
            icon="upload"
            content="Aggiorna status..."
            labelPosition="left"
            size="small"
            primary
            onClick={this.onOpenUpdateStatusSidebar}
          />
        )}
        {this.props.isAdmin && (
          <Button
            style={{ minWidth: '20ex' }}
            icon="edit"
            content="Modifica"
            labelPosition="left"
            size="small"
            primary
            disabled={this.props.selectedRecords.length === 0}
            onClick={this.onModifyRecord}
          />
        )}
        {this.props.isAdmin && (
          <Button
            style={{ minWidth: '20ex', marginRight: '2ex' }}
            icon="delete"
            content="Elimina"
            labelPosition="left"
            size="small"
            color="red"
            disabled={this.props.selectedRecords.length === 0}
            onClick={this.onDeleteDoctor}
          />
        )}
        <FileDownloaderButton
          downloadUrl={'/api/panels/' + this.props.currentCampaign + '/doctors/export'}
          downloadParams={{
            filter: this.props.filter,
            sortKey: this.props.sortKey,
            sortDir: this.props.sortDir,
          }}
          label="Esporta"
          disabled={this.props.totRecords === 0}
          onError={this.onDownloadError}
        />
      </div>
    )
  }
}

const connector: Connector<OwnProps, MappedProps> = connect(mapStateToProps, null)
export default connector(PanelToolbar)



// WEBPACK FOOTER //
// ./src/panels/panel-toolbar.js